import {initHeader} from './header';
import {initCarousel} from './section.carousel';
import {initHeroScreen} from './section.hero-screen';
import {initHeaderH1} from './section.header-h1';
import {initFooter} from './footer';
import {initVideoApartments} from './section.video-apartments';
import {initVideo} from './section.video';

export const initComponents = () => {
	initHeader();
	initCarousel();
	initHeroScreen();
	initHeaderH1();
	initFooter();
	initVideo();
	initVideoApartments();
};
